export const accessibilityOnKeyDown = (event: React.KeyboardEvent) => {
  event.stopPropagation();
  return event.keyCode === 13 || event.key === 'Enter'
    ? (event.target as HTMLElement).click()
    : null;
};
